import React from 'react';
import Dashboard, { Baseline, LoadingPage } from '@myorg/shell';
import {
  PrivateRoute,
  theme,
  stores,
  StoresContext,
  GlobalStyle,
  toastrConfig,
  ModalComponent,
  AlertDialog,
  IframeComponent
} from '@myorg/shared';
import { Helmet } from 'react-helmet';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import { Global } from '@emotion/react';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import Provider from './provider';
import {
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CoreApp = React.lazy(() => import('./routes'));
const BenefitsAdminApp = React.lazy(() => import('@myorg/benefits-admin'));
const BenefitsUserApp = React.lazy(() => import('@myorg/benefits-user'));
const LoginApp = React.lazy(() => import('@myorg/login'));
  
function DefaultFallback({ children, fallback }) {
  return (
    <React.Suspense fallback={fallback || <LoadingPage />}>
      {children}
    </React.Suspense>
  );
}

const Apps = () => {
  const element = useRoutes([
    {
      path: 'auth/*',
      element: (
        <DefaultFallback>
          <Dashboard noMargin>
            <LoginApp />
          </Dashboard>
        </DefaultFallback>
      )
    },
    {
      path: 'indemnizatii-primarie/*',
      element: (
        <PrivateRoute
          element={
            <DefaultFallback>
              <Dashboard>
                <BenefitsUserApp />
              </Dashboard>
            </DefaultFallback>
          }
        />
      )
    },
    {
      path: 'admin-indemnizatii-primarie/*',
      element: (
        <PrivateRoute
          element={
            <DefaultFallback>
              <Dashboard>
                <BenefitsAdminApp />
              </Dashboard>
            </DefaultFallback>
          }
        />
      )
    },
    {
      path: '*', // ar trebui sa duca in page not found
      element: (
        <PrivateRoute
          element={
            <DefaultFallback>
              <Dashboard>
                <CoreApp />
              </Dashboard>
            </DefaultFallback>
          }
        />
      )
    },
    {
      path: '/',
      element: (
        <PrivateRoute
          element={
            <DefaultFallback>
              <Dashboard>
                <CoreApp />
              </Dashboard>
            </DefaultFallback>
          }
        />
      )
    }
  ]);

  return element;
};

function App() {
  return (
    <>
      <Global styles={GlobalStyle} />
      <Toaster position="top-right"  {...toastrConfig}>
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type === 'loading' && (
                  <IconButton
                    onClick={() => toast.dismiss(t.id)}
                    size="small"
                    style={{
                      color: 'white'
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>

      <Baseline />
      <Provider>
        <Helmet>
          <meta charSet="utf-8" />
          {/* Use minimum-scale=1 to enable GPU rasterization */}
          <meta
            name="viewport"
            content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no"
          />
          {/* PWA primary color */}
          <meta name="theme-color" content={theme.palette.primary.main} />
        </Helmet>
        <StoresContext.Provider value={stores}>
          <ModalComponent />
          <IframeComponent />
          <AlertDialog />
          <BrowserRouter basename={process.env.BASE_URL || '/'}>
            <Apps />
          </BrowserRouter>
        </StoresContext.Provider>
      </Provider>
    </>
  );
}

export default App;
